import { initChat } from "./snippet";

initChat("omni-chat-web");